import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import type { NavigationLayoutMode } from '@/hooks/useNavigationPreferences';

export const useNavLayoutMode = (): NavigationLayoutMode => {
  const { user } = useAuth();

  const { data: mode = 'dual-panel' } = useQuery({
    queryKey: ['nav-layout-mode', user?.id],
    queryFn: async () => {
      if (!user?.id) return 'dual-panel' as NavigationLayoutMode;
      const { data, error } = await supabase
        .from('profiles')
        .select('nav_layout_mode')
        .eq('id', user.id)
        .single();
      if (error) throw error;
      return (data?.nav_layout_mode as NavigationLayoutMode) ?? 'dual-panel';
    },
    enabled: !!user?.id,
  });

  return mode;
};
